import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && roles.length && !roles.includes(user.role)) {
    if (user.role === "bar" || user.role === "tickets") return <Navigate to="/scan" replace />;
    if (user.role === "registration" || user.role === "reception") return <Navigate to="/tickets" replace />;
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
